import commonColors from '_/components/common/colors';

const frontendUtilsPalette = {
  IO_AQUA: '#66c2ce',
  IO_COBALT: '#009ee2',
  IO_RUSTY: '#84C2CC',
  IO_STEEL: '#366d93',
  IO_NAVY: '#001760',
  SUCCESS: '#009A5D',
  WARNING: '#F6A624',
  DANGER: '#E20621',
} as const;

export const COLORS: Record<string, string> = Object.freeze({
  ...commonColors,
  ...frontendUtilsPalette,
});
